import _ from 'lodash';
import React from "react";
import Form from "react-jsonschema-form";
import Select from 'react-select';
import {withApollo} from "react-apollo";

import {PinRangeField} from "../../elements/CustomFields";
import {generatePins, project, gq_getConversationalPins} from '../graph';
import {data,schema_default, uiSchema} from "../constants";

import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import IconCard from "components/Cards/IconCard";
import HeaderCard from "components/Cards/HeaderCard";
import Button from "components/CustomButtons/Button";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Snackbar from "views/callform/components/CustomErrorSnackBar";

function ErrorListTemplate(props) {
  const {errors} = props;
  return (
    <div>
      <div className="panel panel-danger errors">
        <div className="panel-heading">
          <h3 className="panel-title">Errors</h3>
        </div>
        <ul className="list-group">
          {errors.map((error, i) => {
            return (
              <li key={i} className="list-group-item text-danger">
                {error.stack}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

class PinGeneration extends React.Component{
  constructor(props){
    super(props)
    this.data = data
    //schema_default[""]
    this.schema_default = schema_default;
    this.uiSchema = uiSchema
    this.fields = {
      pinner: PinRangeField
    };
    this.formData = {};

    this.state = {
      schema: schema_default,
      ui: this.uiSchema,
      fields:this.fields,
      formData: this.formData, 
      order: [],
      controls: [],
      constraint: "None",
      errors: [],
      title:'', 
      errorSnackbarOpen: false
    }
    
    this.addConstraint = this.addConstraint.bind(this)
    this.deleteConstraint = this.deleteConstraint.bind(this)
    this.reflectConstraint = this.reflectConstraint.bind(this)
    this.generatePins = this.generatePins.bind(this)
    this.validateForm = this.validateForm.bind(this)
  }
  addConstraint(event){
    let val = '';
    if (event)
      val = event.value;

    this.setState({
      constraint: val,
      formData: this.formData,
    });
  }
  
  deleteConstraint(row){
    var arr = this.state.controls
    var dupschema = this.state.schema
    
    arr.splice(arr.indexOf(row),1)
    delete dupschema.properties[row]
    delete this.state.formData[row]

    this.setState({
      controls:arr,
      schema:dupschema,
      formData: this.state.formData
    })
  }
  
  reflectConstraint(event){
    /* This adds the constraint to the JSON form */
    event.preventDefault();
    var option = this.state.constraint;
    var opt_list = this.state.controls;
    var temp_schema = this.state.schema;

    if (option === "None"){
      return
    }
    else if (this.state.controls.includes(option) === false){
      opt_list.push(option)
      temp_schema.properties[option] = this.data[option].props
      
      this.setState({
        controls:opt_list,
        schema:temp_schema
      })
    }
    //this.forceUpdate()
  }
  
  generatePins(myobj){
    /* MAIN FORM*/
    /* This is the generate pins form */
    // var formData = myobj.formData;
    let formData = this.formData;

    formData["pid"] = parseInt(this.props.match.params.id);
    let that = this;
      that.props.generatePins({
        variables: {
          inputJson:JSON.stringify(formData)
        }, 
        refetchQueries: (mutationResult) => [ 
          { query:  gq_getConversationalPins, 
            variables: {
              pid: that.props.match.params.id, 
              filterBy: JSON.stringify([]),
              offset: 0, 
              pageSize: 10,
              sort: JSON.stringify([])
            }
          }]
      }).then((result) => {
        if (result.hasOwnProperty('errors')){
          let temp_list = this.state.errors;
          temp_list.push({stack:'Error: User already exist.'});
          that.setState({formData:formData,errors:temp_list});
        }
        else{
          /* Timeout is needed to update the store */ 
          setTimeout(function(){ 
            that.props.history.push(`/projects/${that.props.match.params.id}`);
          }, 1000);  
        }
        this.setState({
          errorSnackbarOpen: false
        })
      }).catch((error) => {
        let err = JSON.parse(error.message.replace("GraphQL error: ", ""))
        this.setState({
          formErrorMessage: err.message, 
          errorSnackbarOpen: true
        })
      });
  }

  validateForm(formData,errors) {
    if (formData.hasOwnProperty('range') === true){
      if (formData.range.min.toString().length != 5 || formData.range.max.toString().length != 5){
        errors.range.addError("Pin should NOT be shorter or longer than 5 digits")
      }
      else if(formData.range.min >= formData.range.max){
        errors.range.addError("Maximum should be greater than minimum value")
      }

    }
    if (formData.hasOwnProperty('group') === true) {
      if (formData.group >99 || formData.group <1){
        errors.group.addError("Value should be between 1-99");
      }
    }

    return errors
  }

  onFormChange(data) {
    this.formData = data.formData;
  }

  closeErrorSnackbar(){
    this.setState({
      errorSnackbarOpen: false, 
    })
  }

  render(){
    let formData = this.state.formData;
    var conf = this.state.schema;
    var main = this;

    return(
      <GridContainer>
        <ItemGrid xs={12} md={4}>
          <IconCard
            icon={DashboardIcon}
            title="Add Constraints"
            content={
              <div>
                <div>
                  <form onSubmit={this.reflectConstraint}>
                    <Select
                      name="constraint-choices"
                      value={this.state.constraint}
                      onChange={this.addConstraint}
                      options={[
                        { value: 'lock', label: 'Lock pin per user' },
                        { value: 'range', label: 'Pins between' },
                        { value: 'group', label: 'Group speaker' },
                      ]}
                    />
                    <br/>
                    <Button color="primary" type="submit">Add</Button>
                  </form>
                </div>
                <div>
                  <table>
                    <tbody>
                      <tr>
                      {
                        this.state.controls.map((row,index) =>
                          {return(
                            <td key={index} className="tdspacer">
                              <a className="btn btn-app" onClick={() => this.deleteConstraint(row)} value={row}>
                                <i className={this.data[row].icon}></i> {this.data[row].verbose}
                              </a>
                            </td>
                          )} 
                        )
                      }
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            }
          />  
          </ItemGrid>

          <ItemGrid xs={12} md={8}>
            <HeaderCard
              cardTitle="Generate Pins"
              content={
                <div>
                  {
                    (main.state.errors.toString().length >0) ? <ErrorListTemplate errors={main.state.errors}/> :null
                  }
                  {
                    (!this.props.project.loading) ? <h4>{this.props.project.project.name}</h4> : null
                  }
                  <Form
                    schema={conf}
                    uiSchema={main.state.ui}
                    onSubmit={main.generatePins}
                    method="post"
                    fields = {main.state.fields}
                    validate = {main.validateForm}
                    formData = {main.state.formData}
                    showErrorList={false}
                    onChange={this.onFormChange.bind(this)}

                  >
                  <Button color="primary" type="submit">Generate</Button>
                  </Form>
                </div>
              }
            />
        </ItemGrid>
        <Snackbar 
          formErrorMessage={this.state.formErrorMessage}
          errorSnackbarOpen={this.state.errorSnackbarOpen}
          closeErrorSnackbar={this.closeErrorSnackbar.bind(this)}
        />
      </GridContainer>
    )
  }
}

export default (generatePins)(withApollo(PinGeneration))



// WEBPACK FOOTER //
// ./src/views/projects/components/PinGeneration.js